import privacyPolicyPopup from "../views/privacyPolicyPopup";

export default [
  {
    path: "/popup/privacyPolicyPopup",
    name: "개인정보처리방침 팝업",
    component: privacyPolicyPopup
  }
];
